import { prefixObjectValues } from '../utils';

const detailPanel = {
  contractOverviewTab: 'contract-overview',
  compensationTab: 'compensation',
  contractTermsTab: 'contract-terms',
  messageBtn: 'message-btn',
  negotiateBtn: 'negotiate-btn',
  applyBtn: 'apply-btn',
  messageConfirmBtn: 'message-confirm-btn',
  negotiateConfirmBtn: 'negotiate-confirm-btn',
  applyConfirmBtn: 'apply-confirm-btn',
  modalSpinner: 'modal-spinner',
  respondedState: 'responded-state',
  viewResponseLink: 'view-response-link',
  ownListingNotice: 'own-listing-notice',
};

export default prefixObjectValues(detailPanel, 'listing-search-detail-panel');
